module.exports = ".pump-delay-time-container ion-item > ion-label {\n  font-size: 18px; }\n"